import {
  GET_EXTERNAL_PROJECTS_COUNTRIES_LOADING,
  GET_EXTERNAL_PROJECTS_COUNTRIES_SUCCESS,
  GET_EXTERNAL_PROJECTS_COUNTRIES_FAILURE,
} from "redux/types";

const initialState = {
  getExternalProjectsCountriesLoading: false,
  externalProjectsCountriesData: null,
  errors: null,
};

export const getExternalProjectsCountriesReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case GET_EXTERNAL_PROJECTS_COUNTRIES_LOADING:
      return { ...state, getExternalProjectsCountriesLoading: action.payload };
    case GET_EXTERNAL_PROJECTS_COUNTRIES_SUCCESS:
      return { ...state, externalProjectsCountriesData: action.payload };
    case GET_EXTERNAL_PROJECTS_COUNTRIES_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
